import { Text as TextComponent } from '@mantine/core'

export const Text = TextComponent.extend({
  styles: () => ({
    root: {
      lineHeight: 1.2,
    },
  }),
})
